import React from 'react';
import styled from 'styled-components';
import AppAvatar, { AppAvatarProps } from '../Avatar/AppAvatar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const IMAGE_MAX_WIDTH = 600;
const IMAGE_MAX_HEIGHT = 300;

const useStyles = makeStyles((theme) => ({
  appAvatarRoot: {
    maxWidth: `${IMAGE_MAX_WIDTH}px`,
    maxHeight: `${IMAGE_MAX_HEIGHT}px`,
    width: '100%',
    height: '100%',
    cursor: 'pointer',

    '& .img': {
      width: '100%',
      height: '100%',
    },
  },
  skeletonRoot: {
    paddingTop: '50%',
  },
}));

const StyledAppAvatar = ({ className, imgProps, ...props }) => {
  const { appAvatarRoot, skeletonRoot } = useStyles();
  return (
    <AppAvatar
      {...props}
      className={appAvatarRoot}
      SkeletonProps={{
        className: skeletonRoot,
      }}
      imgProps={{ ...imgProps, className: 'img' }}
    />
  );
};

const TypoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.grey[400]};
  font-weight: bold;
  padding-top: 50%;
`;
const StyledTypography = styled(Typography)`
  font-weight: bold;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
`;

const BackgroundImageAvatar = ({ children, ...props }: AppAvatarProps) => {
  const theme = useTheme();
  return (
    <StyledAppAvatar variant="square" {...props}>
      <TypoWrapper theme={theme}>
        <StyledTypography>{children}</StyledTypography>
      </TypoWrapper>
    </StyledAppAvatar>
  );
};

export default BackgroundImageAvatar;
